import { z } from "@/helpers/forms/zod";
import { NEW_ORDER_KEY } from "./ModalAddBriefToOrder.constants";

export const modalAddBriefToOrderFormSchema = z
  .object({
    productName: z.string().min(3).max(40),
    orderId: z.string().optional(),
    orderName: z.string().min(3).max(40).optional(),
  })
  .refine(
    (data) =>
      (!!data.orderId && data.orderId !== NEW_ORDER_KEY) || !!data.orderName,
    {
      error: "required",
      path: ["orderName"],
    }
  );

export type InferredModalAddBriefToOrderSchema = z.infer<
  typeof modalAddBriefToOrderFormSchema
>;
